function generateShapes(verticalIntervals, options = {}) {
    let annotations = verticalIntervals.map((int) => {
        return {
            xref: "paper",
            yref: "y",
            x: 0.01,
            y: int.labelLocation,
            xanchor: "left",
            yanchor: "bottom",
            layer: "below",
            font: {
                color: options.color || "white", // Use options.color if provided, default to white
                family: "strong",
                size: 10,
            },
            bgcolor: options.bgcolor || int.color, // Use options.bgcolor if provided
            text: int.label,
            showarrow: false,
        };
    });

    let shapes = verticalIntervals.map((int) => {
        return {
            type: "rect",
            xref: "paper",
            yref: "y",
            x0: 0,
            y0: int.lower,
            x1: 1,
            layer: "below",
            y1: int.upper,
            fillcolor: int.color,
            opacity: int.opacity || 0.4,
            line: {
                width: 0,
            },
        };
    });
    return [annotations, shapes];
}

export default generateShapes;